import { gql } from '../../gql';
import { HazardLevel } from '../../../../components/WaterHazard/HazardLevelPicker';

export const GET_WATER_HAZARD_IDS = gql(`
  query GetWaterHazardIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterHazards(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
    }
  }
`);

export const GET_WATER_HAZARDS = gql(`
  query GetWaterHazards(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterHazards(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      description
      hazardLevel
    }
  }
`);

export type WaterHazardItem = {
  id: string;
  name: string;
  description: string;
  hazardLevel: HazardLevel;
};
